var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonConverter } from 'json2typescript';
var DATE_TIME_FORMAT = new Intl.DateTimeFormat('default', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
    hour12: false,
});
export function dateToISO8601(date) {
    var _a = DATE_TIME_FORMAT.formatToParts(date).reduce(function (acc, part) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[part.type] = part.value, _a)));
    }, {}), year = _a.year, month = _a.month, day = _a.day, hour = _a.hour, minute = _a.minute, second = _a.second;
    return year + "-" + month + "-" + day + "T" + (hour === '24' ? '00' : hour) + ":" + minute + ":" + second + "+0000";
}
var DateConverter = (function () {
    function DateConverter() {
    }
    DateConverter.prototype.serialize = function (date) {
        return dateToISO8601(date);
    };
    DateConverter.prototype.deserialize = function (date) {
        return new Date(date);
    };
    DateConverter = __decorate([
        JsonConverter
    ], DateConverter);
    return DateConverter;
}());
export { DateConverter };
//# sourceMappingURL=Converter.js.map